import { UserApi } from '../../test-api/index.ts'
import useBcBookmarkStore from '@/frontapp/store/bcBookmark'
import Toast from '@/frontapp/mixins/actions/Toast'
import { $t } from 'nette-base-module/js/vuei18next'
import handleApiError from '../../utils/handleApiError'

const userApi = new UserApi({}, '/api/v2')

export default async function (documents, folders) {
  const dto = {}
  const bcBookmarkStore = useBcBookmarkStore()
  if (documents.length) {
    dto['bc_document_ids'] = documents.map(e => e.id)
  }

  if (folders.length) {
    dto['bc_folder_ids'] = folders.map(e => e.id)
  }

  /*const addToBookmarkResponse = */await handleApiError(() => userApi.bookmarkMultipleDelete(dto))

  if (documents.length) {
    documents.forEach(bcBookmarkStore.removeBookmark)
  }

  if (folders.length) {
    folders.forEach(bcBookmarkStore.removeBookmark)
  }

  const sum = documents.length + folders.length
  Toast(
    'success',
    sum === 1 ? $t('Item was unstared') : $t('%cnt% items were unstared', { cnt: sum })
  )
}